import { Form } from '@/types';

export interface FormValue {
	[key: string]: string | string[] | any | any[];
}

export default function getFormValue(form: Form): FormValue {
	const data: FormValue = {};

	Object.keys(form)
		.map((key: string) => {
			// Transform Form to FormValue, data.something = form.value
			// Convert numbers to strings
			const value = form[key].value;
			const field = form[key];

			if (null === value) {
				return null;
			}

			if (Object.prototype.hasOwnProperty.call(field, 'valueToSend')) {
				return data[key] = field.valueToSend || '';
			}

			if (Array.isArray(value)) {
				if ( 'array' === field.type) {
					value.forEach(element => {
						delete element.formRef;
					});
				}

				return data[key] = value as any[];
			}

			return data[key] = value;
		});

	return data;
}
